<div class="card" [formGroup]="form">
  <div class="card-header card-header-detail">
    <span i18n>Abweichende(r) Verpflichtungsgebende(r)</span>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">
          <label for="verpflichtungserklaerungsgeber.art" i18n [class.mandatory]="isMandatory('art')">Art des/der Verpflichtungsgebenden:</label>
          <select class="form-select form-select-sm"
                  id="verpflichtungserklaerungsgeber.art"
                  [class.is-invalid]="errorClassRequired(form.controls['art'])"
                  formControlName="art"
                  [ngbPopover]="popover_verpflichtungserklaerungsgeber_art"
                  appSaveLastFocussed
          >
            <option *ngFor="let listItem of verpflichtungserklaerungsgeberListItems"
                    value="{{ listItem.key }}">{{ listItem.value }}
            </option>
          </select>
          <ng-template #popover_verpflichtungserklaerungsgeber_art>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier die Art des/der abweichenden Verpflichtungsgebenden für den beabsichtigten Aufenthalt des/der Antragstellenden ein.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Person oder Akkreditierter Diplomat -->
    <div *ngIf="['1','3'].indexOf(form.value['art']) >= 0">

      <div class="row" *ngIf="['3'].indexOf(form.value['art']) >= 0"> <!-- Akkreditierter Diplomat -->
        <div class="col-md-8">
          <div class="mb-3">
            <label
              for="verpflichtungserklaerungsgeber.organisation.name"
              i18n="@@name-der-institution-bzw-der-botschaft-oder-des-ge"
              [class.mandatory]="isMandatory('orgaName')"
            >Name der Institution bzw. der Botschaft oder des Generalkonsulats:</label>
            <input id="verpflichtungserklaerungsgeber.organisation.name"
                   type="text"
                   appToUpperCase [attr.maxlength]="getMaxLength('orgaName')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['orgaName'])"
                   formControlName="orgaName"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_name"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_name>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Wenn es sich bei der Art des/der abweichenden Verpflichtungsgebenden um eine Organisation/Firma oder um einen akkreditierten Diplomaten handelt, tragen Sie hier bitte den Namen der Organisation/Firma oder der diplomatischen oder konsularischen Vertretung ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.familienname" i18n [class.mandatory]="isMandatory('familienname')"
            >Familienname der Ansprechperson:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.familienname"
                   type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('familienname')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['familienname'])"
                   formControlName="familienname"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_familienname"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_familienname>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Familiennamen der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.vorname" i18n="@@vornamen-der-ansprechperson"
                   [class.mandatory]="isMandatory('vorname')">Vorname(n) der Ansprechperson:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.vorname"
                   type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorname')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['vorname'])"
                   formControlName="vorname"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_vorname"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_vorname>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den/die Vornamen der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">

          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.geschlecht" i18n
                   [class.mandatory]="isMandatory('geschlecht')">Geschlecht:</label>
            <select class="form-select form-select-sm" [class.is-invalid]="errorClassRequired(form.controls['geschlecht'])"
                    formControlName="geschlecht" id="verpflichtungserklaerungsgeber.ansprechpartner.geschlecht"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_geschlecht"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of geschlechtListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_geschlecht>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span
                  i18n>Bitte tragen Sie hier das Geschlecht der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.geburtsdatum" i18n [class.mandatory]="isMandatory('geburtsdatum')"
            >Geburtsdatum (TT.MM.JJJJ):</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.geburtsdatum"
                   type="text"
                   appDynamicDateMaxLength
                   appFixDate="past" unknownReplacement="00"
                   class="form-control form-control-sm" [class.is-invalid]="errorClassRequired(form.controls['geburtsdatum'])"
                   formControlName="geburtsdatum"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsdatum"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsdatum>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier das Geburtsdatum (im Format TT.MM.JJJJ) der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.geburtsort" i18n
                   [class.mandatory]="isMandatory('geburtsort')">Geburtsort:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.geburtsort" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('geburtsort')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['geburtsort'])" formControlName="geburtsort"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsort"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsort>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span
                  i18n>Bitte tragen Sie hier den Geburtsort der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.staatsangehoerigkeit" [class.mandatory]="isMandatory('staatsangehoerigkeit')" i18n>Staatsangehörigkeit:</label>
            <select class="form-select form-select-sm" id="verpflichtungserklaerungsgeber.ansprechpartner.staatsangehoerigkeit"
                    [class.is-invalid]="errorClassRequired(form.controls['staatsangehoerigkeit'])" formControlName="staatsangehoerigkeit"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_staatsangehoerigkeit"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_staatsangehoerigkeit>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Staatsangehörigkeit der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.strasse" i18n
                   [class.mandatory]="isMandatory('strasse')">Straße:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.strasse" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('strasse')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['strasse'])" formControlName="strasse"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_strasse"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_strasse>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Straße der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.hausnummer" i18n [class.mandatory]="isMandatory('hausnummer')">Hausnummer:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.hausnummer" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('hausnummer')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['hausnummer'])" formControlName="hausnummer"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_hausnummer"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_hausnummer>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Hausnummer der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.plz" i18n
                   [class.mandatory]="isMandatory('plz')">Postleitzahl:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.plz" type="text" appToUpperCase [attr.maxlength]="getMaxLength('plz')"
                   class="form-control form-control-sm" [class.is-invalid]="errorClassRequired(form.controls['plz'])"
                   formControlName="plz"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_plz"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_plz>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Postleitzahl der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.ort" i18n [class.mandatory]="isMandatory('ort')">Ort:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.ort" type="text" appToUpperCase [attr.maxlength]="getMaxLength('ort')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['ort'])" formControlName="ort"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_ort"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_ort>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Ort der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.land" i18n [class.mandatory]="isMandatory('land')">Land:</label>
            <select class="form-select form-select-sm" id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.land"
                    [class.is-invalid]="errorClassRequired(form.controls['land'])"
                    formControlName="land"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_land"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of landListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_land>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier das Land der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.telefon" i18n [class.mandatory]="isMandatory('telefon')">Telefon-/Mobilfunknummer:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.telefon" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('telefon')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['telefon'])" formControlName="telefon"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_telefon"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_telefon>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die aktuelle Telefonnummer des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.email" i18n
                   [class.mandatory]="isMandatory('email')">E-Mail:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.email" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('email')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['email'])" formControlName="email"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_email"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_email>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Person -->
      <div class="row" *ngIf="['1'].indexOf(form.value['art']) >= 0">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.abweichendeSchreibweiseNachname" i18n
                   [class.mandatory]="isMandatory('abweichendNachname')">Abweichende Schreibweise - Nachname(n):</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.abweichendeSchreibweiseNachname" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('abweichendNachname')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['abweichendNachname'])"
                   formControlName="abweichendNachname"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_abweichendeSchreibweiseNachname"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_abweichendeSchreibweiseNachname>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Familiennamens der Person, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.abweichendeSchreibweiseVorname" i18n
                   [class.mandatory]="isMandatory('abweichendVorname')">Abweichende Schreibweise - Vorname(n):</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.abweichendeSchreibweiseVorname" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('abweichendVorname')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['abweichendVorname'])" formControlName="abweichendVorname"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_abweichendeSchreibweiseVorname"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_abweichendeSchreibweiseVorname>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Vornamens der Person, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Person -->
      <div class="row" *ngIf="['1'].indexOf(form.value['art']) >= 0">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.andereNamen" i18n [class.mandatory]="isMandatory('andereNamen')"
            >Andere Namen:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.andereNamen" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('andereNamen')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['andereNamen'])" formControlName="andereNamen"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_andereNamen"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_andereNamen>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier, sofern vorhanden, andere Namen der Person, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.fruehereNamen" i18n [class.mandatory]="isMandatory('fruehereNamen')"
            >Frühere Namen:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.fruehereNamen" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('fruehereNamen')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['fruehereNamen'])" formControlName="fruehereNamen"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_fruehereNamen"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_fruehereNamen>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier, sofern vorhanden, frühere Namen der Person, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Organisation/Firma -->
    <div *ngIf="['2'].indexOf(form.value['art']) >=0 ">
      <div class="row">

        <div class="col-md-8">
          <div class="mb-3">
            <label
              for="verpflichtungserklaerungsgeber.organisation.name"
              i18n="@@name-der-institution-bzw-der-botschaft-oder-des-ge"
              [class.mandatory]="isMandatory('orgaName')">Name der Institution bzw. der Botschaft oder des Generalkonsulats:</label>
            <input id="verpflichtungserklaerungsgeber.organisation.name" type="text" appToUpperCase [attr.maxlength]="getMaxLength('orgaName')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['orgaName'])" formControlName="orgaName"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_name"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_name>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Wenn es sich bei der Art des/der abweichenden Verpflichtungsgebenden um eine Organisation/Firma oder um einen akkreditierten Diplomaten handelt, tragen Sie hier bitte den Namen der Organisation/Firma oder der diplomatischen oder konsularischen Vertretung ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.organisation.sitz" i18n="@@sitz-der-organisation-ort"
                   [class.mandatory]="isMandatory('orgaSitz')"
            >Sitz der Organisation, Ort:</label>
            <input id="verpflichtungserklaerungsgeber.organisation.sitz" type="text" appToUpperCase [attr.maxlength]="getMaxLength('orgaSitz')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['orgaSitz'])" formControlName="orgaSitz"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_sitz"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_sitz>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Ort der Organisation oder der Firma ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.organisation.land" i18n="@@sitz-der-organisation-land">Sitz der Organisation, Land:</label>
            <select class="form-select form-select-sm" id="verpflichtungserklaerungsgeber.organisation.land"
                    [class.is-invalid]="errorClassRequired(form.controls['orgaSitzLand'])" formControlName="orgaSitzLand"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_land"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of landListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_land>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier das Land der Organisation oder der Firma ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.organisation.wirkungsbereich" i18n [class.mandatory]="isMandatory('orgaAufgabe')"
            >Aufgabenstellung / Wirkungsbereich der Organisation:</label>
            <select class="form-select form-select-sm" [class.is-invalid]="errorClassRequired(form.controls['orgaAufgabe'])"
                    formControlName="orgaAufgabe" id="verpflichtungserklaerungsgeber.organisation.wirkungsbereich"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_wirkungsbereich"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of wirkungsbereichListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>

            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_wirkungsbereich>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Wirkungsbereich der Organisation oder der Firma ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.organisation.registerName" i18n [class.mandatory]="isMandatory('orgaRegisterName')"
            >Name des Registers der Organisation:</label>
            <select class="form-select form-select-sm" [class.is-invalid]="errorClassRequired(form.controls['orgaRegisterName'])"
                    formControlName="orgaRegisterName" id="verpflichtungserklaerungsgeber.organisation.registerName"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_registerName"
                    appSaveLastFocussed
            >
              <option value="" selected></option>
              <option *ngFor="let listItem of registerListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_registerName>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Namen des Registers der Organisation oder der Firma ein, in dem diese registriert ist.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.organisation.registerOrt" i18n [class.mandatory]="isMandatory('orgaRegisterOrt')"
            >Ort des Registers:</label>
            <input id="verpflichtungserklaerungsgeber.organisation.registerOrt" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('orgaRegisterOrt')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['orgaRegisterOrt'])" formControlName="orgaRegisterOrt"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_registerOrt"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_registerOrt>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Ort des Registers der Organisation oder der Firma ein, an dem diese registriert ist.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.organisation.registerNummer" i18n [class.mandatory]="isMandatory('orgaRegisternummer')">Registernummer:</label>
            <input id="verpflichtungserklaerungsgeber.organisation.registerNummer" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('orgaRegisternummer')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['orgaRegisternummer'])"
                   formControlName="orgaRegisternummer"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_organisation_registerNummer"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_organisation_registerNummer>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Registernummer ein, unter der die Organisation oder die Firma registriert ist.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.familienname" i18n [class.mandatory]="isMandatory('familienname')"
            >Familienname der Ansprechperson:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.familienname" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('familienname')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['familienname'])" formControlName="familienname"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_familienname"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_familienname>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Familiennamen der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.vorname" i18n="@@vornamen-der-ansprechperson"
                   [class.mandatory]="isMandatory('vorname')">Vorname(n) der Ansprechperson:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.vorname" type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorname')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['vorname'])" formControlName="vorname"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_vorname"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_vorname>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den/die Vornamen der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">

          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.geschlecht" i18n
                   [class.mandatory]="isMandatory('geschlecht')">Geschlecht:</label>
            <select class="form-select form-select-sm" [class.is-invalid]="errorClassRequired(form.controls['geschlecht'])"
                    formControlName="geschlecht" id="verpflichtungserklaerungsgeber.ansprechpartner.geschlecht"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_geschlecht"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of geschlechtListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>

            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_geschlecht>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span
                  i18n>Bitte tragen Sie hier das Geschlecht der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.geburtsdatum" i18n [class.mandatory]="isMandatory('geburtsdatum')"
            >Geburtsdatum (TT.MM.JJJJ):</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.geburtsdatum"
                   type="text"
                   appDynamicDateMaxLength
                   appFixDate="past" unknownReplacement="00"
                   class="form-control form-control-sm" [class.is-invalid]="errorClassRequired(form.controls['geburtsdatum'])"
                   formControlName="geburtsdatum"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsdatum"
                   appSaveLastFocussed
            >

          </div>
          <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsdatum>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier das Geburtsdatum (im Format TT.MM.JJJJ) der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
            </app-assistant>
          </ng-template>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.geburtsort" i18n
                   [class.mandatory]="isMandatory('geburtsort')">Geburtsort:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.geburtsort" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('geburtsort')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['geburtsort'])" formControlName="geburtsort"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsort"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_geburtsort>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span
                  i18n>Bitte tragen Sie hier den Geburtsort der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.staatsangehoerigkeit" i18n>Staatsangehörigkeit:</label>
            <select class="form-select form-select-sm" id="verpflichtungserklaerungsgeber.ansprechpartner.staatsangehoerigkeit"
                    [class.is-invalid]="errorClassRequired(form.controls['staatsangehoerigkeit'])" formControlName="staatsangehoerigkeit"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_staatsangehoerigkeit"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of staatsangehoerigkeitListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_staatsangehoerigkeit>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Staatsangehörigkeit der Person bzw. der Ansprechperson der Organisation, die die Kosten übernimmt, ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.strasse" i18n
                   [class.mandatory]="isMandatory('strasse')">Straße:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.strasse" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('strasse')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['strasse'])" formControlName="strasse"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_strasse"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_strasse>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Straße der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.hausnummer" i18n [class.mandatory]="isMandatory('hausnummer')">Hausnummer:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.hausnummer" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('hausnummer')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['hausnummer'])" formControlName="hausnummer"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_hausnummer"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_hausnummer>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Hausnummer der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.plz" i18n
                   [class.mandatory]="isMandatory('plz')">Postleitzahl:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.plz" type="text" appToUpperCase [attr.maxlength]="getMaxLength('plz')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['plz'])" formControlName="plz"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_plz"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_plz>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die Postleitzahl der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.ort" i18n [class.mandatory]="isMandatory('ort')">Ort:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.ort" type="text" appToUpperCase [attr.maxlength]="getMaxLength('ort')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['ort'])" formControlName="ort"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_ort"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_ort>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier den Ort der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.land" i18n [class.mandatory]="isMandatory('land')">Land:</label>
            <select class="form-select form-select-sm" id="verpflichtungserklaerungsgeber.ansprechpartner.anschrift.land"
                    [class.is-invalid]="errorClassRequired(form.controls['land'])" formControlName="land"
                    [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_land"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let listItem of landListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>

            </select>
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_anschrift_land>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier das Land der aktuellen Anschrift des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.telefon" i18n [class.mandatory]="isMandatory('telefon')">Telefon-/Mobilfunknummer:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.telefon" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('telefon')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['telefon'])" formControlName="telefon"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_telefon"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_telefon>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die aktuelle Telefonnummer des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.email" i18n
                   [class.mandatory]="isMandatory('email')">E-Mail:</label>
            <input id="verpflichtungserklaerungsgeber.ansprechpartner.kontaktdaten.email" type="text" appToUpperCase
                   [attr.maxlength]="getMaxLength('email')" class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['email'])" formControlName="email"
                   [ngbPopover]="popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_email"
                   appSaveLastFocussed
            >
            <ng-template #popover_verpflichtungserklaerungsgeber_ansprechpartner_kontaktdaten_email>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse des/der abweichenden Verpflichtungsgebenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
